import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-infringement-status',
  templateUrl: './infringement-status.component.html',
  styleUrls: ['./infringement-status.component.css'],
})
export class InfringementStatusComponent {
  @Input() userMdmid: string = '';
  constructor(
    private router: Router,
  ) { }

  onCreateInfringement(event: any) {
    this.router.navigateByUrl('/infractions');
  }
}
